import React from 'react'
import { ScaleLinear } from 'd3-scale'
import { formatSwissDate, config } from '../Charts_Assets'
type ttDataType = {
  data: { d: string; v: number }[]
  pos: { x: number; anchor: 'start' | 'end' | 'middle' }
}
export const Tooltip = ({
  data,
  y
}: {
  data: ttDataType
  y: ScaleLinear<number, number>
}) => {
  let textYValues = data.data
    .map(m => Math.min(y.range()[0] + y.range()[1] - y(m.v), y.range()[0]))
    .sort((a, b) => a - b)
  let currentY = y.range()[0] + y.range()[1] - y(data.data[0].v)

  textYValues = textYValues.map((m, i) => {
    if (textYValues[i + 1]) {
      if (m > textYValues[i + 1] - 13) {
        textYValues[i + 1] = Math.min(m + 13, y.range()[0] - 4)
      }
      if (m > y.range()[0] - 13 && textYValues[i + 1] === y.range()[0] - 4) {
        m = m - 17
      }
    }
    return m
  })

  return (
    <g transform={`translate(${data.pos.x},0)`} className='Tooltip'>
      <line
        y1={
          y.range()[0] + y.range()[1] - y(Math.max(...data.data.map(m => m.v)))
        }
        y2={y.range()[0]}
        stroke='#000'
        className='tickline'
      />
      {data.data
        .sort((a, b) => b.v - a.v)
        .map((m, i) => {
          return (
            <>
              <circle
                className='ttMarker inner'
                r={3}
                cy={y.range()[0] + y.range()[1] - y(m.v)}
              />

              <text
                className='ttVal bg'
                x={data.pos.anchor === 'end' ? -20 : +20}
                y={textYValues[i]}
                textAnchor={data.pos.anchor}
              >
                {Math.round(m.v)}
              </text>
              <text
                className='ttVal'
                x={data.pos.anchor === 'end' ? -20 : +20}
                y={textYValues[i]}
                textAnchor={data.pos.anchor}
              >
                {Math.round(m.v)}
              </text>
            </>
          )
        })}
      <text
        className='ttDate bg'
        y={y.range()[0] + config.textOffsetY}
        textAnchor={'middle'}
      >
        {formatSwissDate(data.data[0].d)}
      </text>
      <text
        className='ttDate'
        y={y.range()[0] + config.textOffsetY}
        textAnchor={'middle'}
      >
        {formatSwissDate(data.data[0].d)}
      </text>
    </g>
  )
}
